export const formatClassicWholeMoney = (value, { empty = "" } = {}) => {
  if (value === null || value === undefined || value === "") return empty;
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return empty;
  return Math.round(numericValue).toLocaleString("he-IL", {
    maximumFractionDigits: 0
  });
};
